import React, { memo } from "react";
import AerosNode, { OptionList, OptionRow } from "./AerosNode";

export default memo(({ data, isConnectable, id, selected }) => (
  <AerosNode
    id={id}
    type="randomizer"
    selected={selected}
    isConnectable={isConnectable}
    hasSource={false}
    options={
      <OptionList>
        <OptionRow badge="A" label={`${data.percent}%`} tone="logic" handleId="a" isConnectable={isConnectable} />
        <OptionRow badge="B" label={`${100 - data.percent}%`} tone="logic" handleId="b" isConnectable={isConnectable} />
      </OptionList>
    }
  />
));
